export default "__VITE_ASSET__52eb3593__"